/**
 * Mapeia o campo `navegar` do push (mesmo contrato de cotação/serviço/mensagem)
 * para a rota interna do React Router.
 *
 * Cotação/serviço/mensagem usam: servico-cotacao, servico-execucao, servico-mensagens
 * Gestão de vagas: gestao-vagas (e aliases legados)
 */
export default function validarRedirecionamento(chave) {
	const k = (chave || '').toString().trim()
	switch (k) {
		case 'servico-execucao':
		case 'servico':
			return '/app/servicos'
		case 'servico-cotacao':
		case 'cotacao':
			return '/app/cotacoes'
		case 'servico-mensagens':
		case 'mensagem':
			return '/app/mensagens'
		case 'gestao-vagas':
		case 'gestao_vagas':
		case 'gestao_vagas_lembrete':
		case 'gestao-vagas-confirmacao':
		case 'gestao-vagas-lembrete':
			return '/app/gestaoVaga'
		case 'dados-adicionais':
		case 'dadosUsuario':
			return '/app/dadosUsuario'
		default:
			return '/home'
	}
}
